export default __webpack_public_path__ + "static/media/Recipes.b07ceea1.png";